import { JATOTheme } from '@jato/ui-component-library'
import styled from 'styled-components'

export const StyledVolumesNewsArticles = styled.div`
  .accordion-container {
    border: 1px solid ${JATOTheme.colors.grey};
    font-size: 14px;
  }

  .accordion-content {
    word-wrap: break-word;
    line-height: 1.6;
  }

  .itemTitle {
    font-weight: 500;
    padding: 6px 16px;
    background-color: ${JATOTheme.colors.midGrey};
  }

  .itemContent {
    padding: 6px 16px;
    display: flex;
    flex-flow: column;
    gap: 5px;
  }
`
